import { render, staticRenderFns } from "./LayoutGeneral.vue?vue&type=template&id=70d0d7e0&scoped=true&"
import script from "./LayoutGeneral.vue?vue&type=script&lang=js&"
export * from "./LayoutGeneral.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGeneral.vue?vue&type=style&index=0&id=70d0d7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0d7e0",
  null
  
)

export default component.exports